import { useSearchParams } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { getSearchParams } from '@app/helpers/urlHelper';

export type UrlParams = { [key: string]: string };
export type Params = { [key: string]: any };

export const useUrlParams = (location?: string) => {
  const [searchParams] = useSearchParams();
  const [urlParams, setUrlParams] = useState<Params | null>(null);

  useEffect(() => {
    const params = getSearchParams(searchParams);

    if (Object.keys(params).length !== 0) {
      if (location && params['location'] !== location) {
        setUrlParams({});
        return;
      }

      setUrlParams(params);
    } else {
      setUrlParams({});
    }
  }, []);

  return { urlParams };
};
